import { F0Button } from '@factorialco/f0-react'
import { CrossedCircle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { useSelectionDispatch } from 'modules/shift_management/hooks/useSelection'

const ClearSelectionButton = () => {
  const dispatchSelection = useSelectionDispatch()

  const onClick = () => {
    dispatchSelection({
      type: 'CLEAR_SELECTION',
    })
  }

  return (
    <F0Button
      variant="outline"
      onClick={onClick}
      disabled={false}
      icon={CrossedCircle}
      label={i18n.t('shift_management.clear_selection')}
    />
  )
}

export default ClearSelectionButton
